export const ver = 'D4103'
import { router } from "@/router"
// import { Api as $api } from '@/api'
import { Toast } from "vant"

export const verData = {
  D4103: {
    title: 'Easyloan Personal Finance',
    moneyType: '₱',
    needBank: true,
    areaCode: 1,
    lan: 'en',
    needCode: true,
    url: 'https://bsp888.cc/',
    bankInput: true,
    vipHide: false,
    bankCardLimit: 11,
    levelType: 'recharge',
    newRecharge: true, // 新版本修改后新增参数
    useNewMine: true,
    allowedMoreCard: true,
    pathNewRecharge: true, // 跳转新的充值页面
    homeProfitInterval: [10, 5000],
    homeProfitIntervalMax: [11500, 11999],
    useNewWithdraw: false,
    theme: "#FFD700",
    themes: 'light',
    navBg: "#000",
    btnColor: '#424242',
    noticeIconColor: "#000",
    selectCurrency: false,
    homeShowTradeBar: true,
    homeShowAboutBar: true,
    useIngegrante: true,
    homeShowInvite: true,
    mineHasCommissionRecords: true,
    hasManyBank: true,
    tabbar: {
      selectedColor: "#FFD700",
      pages: [{
        text: 'newTab.home',
        type: 'image',
        pagePath: 'goods',
        component: () => import("@/view/goods"),
        iconPath: require('@/assets/Img/tabber/home.png'),
        selectedIconPath: require('@/assets/Img/tabber/home_active.png'),
        isSpecial: false,
      }, {
        type: 'image',
        text: `${'newTab.my'}`,
        pagePath: 'user',
        component: () => import('@/view/user'),
        iconPath: require('@/assets/Img/tabber/user.png'),
        selectedIconPath: require('@/assets/Img/tabber/user_active.png'),
        isSpecial: false,
      }]
    },
    nullPng: require("@/assets/Img/null/T7399.png"),
    unreadBg: "#fcc400",
    unreadColor: "#000",
    homeTheme: "#0073e4"
  },
}

export default verData[ver]
